import isIE11 from '../util/isIE11';
import urlUtil from '../util/url';
import header from '../layout/header';
import footer from '../layout/footer';

export default {
  init() {
    if (isIE11()) {
      $('body').addClass('msie');
    }
    header();
    footer();

    Math.easeInOutQuad = function (t, b, c, d) {
      t /= d/2;
      if (t < 1) return c/2*t*t + b;
      t--;
      return -c/2 * (t*(t-2) - 1) + b;
    };
  },
  finalize() {

    // JavaScript to be fired on all pages, after page specific JS is fired
    function resizeIframe(iframe) {
      iframe.height = iframe.contentWindow.document.body.scrollHeight + 'px';
    }

    console.log(resizeIframe)

    // stick on scroll
    $(window).on('scroll', function(){
      if ($(window).scrollTop() > 0) {
        $('body').addClass('has-fixed-header');
      } else {
        $('body').removeClass('has-fixed-header');
      }
    });

    // UTM Links
    $(function(){

      // Save data
      try{
        var utm_source    = urlUtil.getUrlParameter('utm_source')   ||  ''
        var utm_medium    = urlUtil.getUrlParameter('utm_medium')   ||  ''
        var utm_campaign  = urlUtil.getUrlParameter('utm_campaign') ||  ''

        if( utm_source || utm_medium || utm_campaign ) {

          // Remove Old
          window.localStorage.removeItem('binah_utm_source');
          window.localStorage.removeItem('binah_utm_medium');
          window.localStorage.removeItem('binah_utm_campaign');

          // Save New Data
          window.localStorage.setItem('binah_utm_source', utm_source);
          window.localStorage.setItem('binah_utm_medium', utm_medium);
          window.localStorage.setItem('binah_utm_campaign', utm_campaign);
        }
      }
      catch(err){
        // console.error(err);
      }

      // Fill inputs
      try {
        if( $('form.contact-salesforce-form').length > 0 ) {
          var get_utm_source   = window.localStorage.getItem('binah_utm_source');
          var get_utm_medium   = window.localStorage.getItem('binah_utm_medium');
          var get_utm_campaign = window.localStorage.getItem('binah_utm_campaign');

          // Set Form Data
          if(get_utm_source)   $('input[type="hidden"][name="Lead_Referral__c"]').val(get_utm_source);
          if(get_utm_source)   $('input[type="hidden"][name="lead_referral"]').val(get_utm_source);
          if(get_utm_medium)   $('input[type="hidden"][name="utm_medium"]').val(get_utm_medium);
          if(get_utm_campaign) $('input[type="hidden"][name="utm_campaign"]').val(get_utm_campaign);
          $('#00N1t00000KznAN').val(get_utm_campaign);
          $('#00N1t00000KzYau').val(get_utm_source);
          $('#00N1t00000KznAI').val(get_utm_medium);
        }
      }
      catch(err) {
        // console.error(err);
      }

      // Clear
      try {
        $(document).on('submit', 'form.contact-salesforce-form', function(){
          window.localStorage.removeItem('binah_utm_source');
          window.localStorage.removeItem('binah_utm_medium');
          window.localStorage.removeItem('binah_utm_campaign');
        });
      }
      catch(err) {
        // console.error(err);
      }

      // Go to top
      $(function () {

        function scrollTo(to, duration) {
          const element = document.scrollingElement;
          const start = (element && element.scrollTop) || window.pageYOffset,
              change = to - start,
              increment = 20;
          let currentTime = 0;

          const animateScroll = function(){
              currentTime += increment;
              const val = Math.easeInOutQuad(currentTime, start, change, duration);
              window.scrollTo(0, val);
              if(currentTime < duration) {
                  window.setTimeout(animateScroll, increment);
              }
          };
          animateScroll();
        }

        $('.btn-go-to-top').click(function(e){
          e.preventDefault();
          scrollTo(0, 800);
        });

      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js